import * as React from "react";
import PropTypes from "prop-types";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Grid
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import LoadStatusPill from "../../Pills/LoadStatusPill/LoadStatusPill";

export default function SidebarLoadItem({ load, index, handleBookmark, handleTableAction }) {
  return (
    <ListItem>
      <ListItemIcon>
        <LoadStatusPill value={load.status} darkTheme large />
      </ListItemIcon>
      <ListItemText>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item xs={8}>
            <Typography
              variant="body2"
              onClick={() => handleTableAction({ action: "load-profile", loadId: load.loadId })}
              sx={{
                color: "black_solid.50",
                cursor: "pointer"
              }}>
              {load.lane}
            </Typography>
          </Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={2}>
            {load.isBookmark ?
              <BookmarkIcon
                onClick={() => handleBookmark(index, load)}
                sx={{ fontSize: "15px", color: "black_solid.50", cursor: "pointer" }}
              />
              :
              <BookmarkBorderIcon
                onClick={() => handleBookmark(index, load)}
                sx={{ fontSize: "15px", color: "black_solid.50", cursor: "pointer" }}
              />
            }
          </Grid>
        </Grid>
      </ListItemText>
    </ListItem>
  );
}

SidebarLoadItem.propTypes = {
  load: PropTypes.object.isRequired,
  index: PropTypes.number,
  handleBookmark: PropTypes.func,
  handleTableAction: PropTypes.func
};